import { FC, Fragment } from "react";
import { Link } from "react-router-dom";

interface AppEmptyProps {
    title?: string;
    description?: string;
    actionText?: string;
    actionHref?: string;
    actionOnClick?: () => void;
}

const AppEmpty: FC<AppEmptyProps> = ({
    title = "Không có dữ liệu",
    description = "Hiện tại chưa có nội dung để hiển thị.",
    actionText,
    actionHref,
    actionOnClick
}) => {
    return (
        <div className="flex flex-col items-center justify-center px-4 text-center text-gray-600">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-3 p-2">
                <i className="fa-regular fa-message text-blue-500 text-2xl m-4"></i>
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">{title}</h2>
            <p className="text-gray-500 mb-6 max-w-md">{description}</p>

            {actionText && (actionHref || actionOnClick) && <Fragment>
                {
                    actionHref ? <Link
                        to={actionHref}
                        onClick={actionOnClick}
                        className="bg-blue-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-blue-700 transition"
                    >
                        {actionText}
                    </Link> :
                        <button
                            onClick={actionOnClick}
                            className="bg-blue-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-blue-700 transition"
                        >
                            {actionText}
                        </button>}
            </Fragment>}
        </div>
    );
};

export default AppEmpty;
